import React, { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  getSupersheetAPI,
  getStateAll,
  getGradeAll,
  updateSupersheetAPI,
  postSupersheetAPI,
  getSupersheetSubjectsByIdAPI,
} from "../../../api/supersheet.service";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import constant from "../../../utils/constant";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, Link } from "react-router";
import Loader from "../../shared/loader/loader";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import { toast } from "react-toastify";
import SupersheetFile from "./supersheetFilePreview";
import { ISupersheet } from "../../../model/interface/supersheet";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiSelect from "../../shared/common/multiSelect";
import { useNumericParam } from "../../../utils/useNumericParam";

export const ManageSupersheet = (props: any) => {
  const defaultValue: any = {};
  const defaultSelectValue: ISelectElement = { label: "", value: "0" };
  const supersheetData: ISupersheet = {
    superSheetId: 0,
    title: "",
  };

  const [contentArea, setContentArea] = useState([]);
  const [states, setStates] = useState([]);
  const [grades, setGrades] = useState([]);
  const [supersheetInput, setSupersheetInput] = useState(defaultValue);
  const [selectedState, setSelectedState] = useState(defaultValue);
  const [selectedGrade, setSelectedGrade] = useState(defaultValue);
  const [selectedContentArea, setSelectedContentArea] = useState(defaultValue);
  const [contentAreas, setContentAreas] = useState<ISelectElement[]>([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState<any>([]);
  const [selectedSupersheetFile, setSelectedSupersheetFile] = useState<any>();
  const [selectedRationalesFile, setSelectedRationalesFile] = useState<any>();
  const [subjects, setSubjects] = useState<ISelectElement[]>([]);
  const [selectedSubject, setSelectedSubject] =
    useState<ISelectElement>(defaultValue);
  type tabName = "EnglishQuestionPDF" | "EnglishRationales";
  const [activeTab, setActiveTab] = useState<tabName>("EnglishQuestionPDF");

  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";
  const [supersheet, setSupersheet] = useState<ISupersheet>(supersheetData);

  const [lang, setLang] = useState<number>(1);
  let successMessage: string;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const navigate = useNavigate();
  const id = useNumericParam("id");
  const subjectId = useNumericParam("subjectId");

  const location = useLocation();
  const parameters = location.state as any;
  const [loading, setLoading] = useState<boolean>(false);

  const submitHandler = async (data) => {
    setIsLoaded(true);
    setLoading(true);

    if (data.title) {
      const formData = new FormData();
      formData.append(
        "questionPDFFile",
        selectedSupersheetFile !== null ? selectedSupersheetFile : ""
      );
      formData.append(
        "rationalesCSVFile",
        selectedRationalesFile !== null ? selectedRationalesFile : ""
      );
      formData.append("title", data.title);
      formData.append(
        "isSpanish",
        lang === 2 ? true.toString() : false.toString()
      );
      formData.append("contentAreaId", selectedContentArea?.value?.toString());
      formData.append("stateId", selectedState.value);
      // formData.append("subjectId", selectedSubject.value);
      formData.append(
        "GradeId",
        selectedGrade !== null ? selectedGrade.value : 0
      );

      if (selectedSubjects && selectedSubjects.length > 0) {
        const subjectIdList: any = [];
        const mainSubject = selectedSubjects.find(
          (x) => x.value == selectedSubject.value
        );
        if (mainSubject) {
          formData.append("subjectId", selectedSubject.value);
          selectedSubjects.forEach((sub) => {
            if (sub.value !== mainSubject.value) {
              subjectIdList.push(sub.value);
            }
          });
        } else {
          formData.append("subjectId", selectedSubjects[0].value);
          for (let i = 1; i < selectedSubjects.length; i++) {
            subjectIdList.push(selectedSubjects[i].value);
          }
        }
        for (let i = 0; i < subjectIdList.length; i++) {
          formData.append("shareSubjectIds[]", subjectIdList[i]);
        }
      }

      if (id) {
        formData.append("supersheetId", id?.toString());
        await updateSupersheetAPI(formData);
        navigate(constant.SUPERSHEETS);
        successMessage = "Supersheet Updated Successfully";
      } else {
        const data = await postSupersheetAPI(formData);
        navigate(constant.SUPERSHEETS);
        successMessage = `Supersheet Added Successfully, ID- ${data.data}`;
      }
      setLoading(false);

      const module = await import("react-toastify");
      module.toast.success(successMessage);
    }
  };

  useEffect(() => {
    if (id) {
      getSupersheet(id);
    } else {
      bindContentAreas();
      getGrades();
      getStates();
    }
  }, [id]);

  const getSupersheet = async (id: number) => {
    setLoading(true);
    let response: any = await getSupersheetAPI(id);
    response = (await response).data;

    const supersheetSubjects = await getSupersheetSubjectsByIdAPI(id);

    setLoading(false);
    if (response) {
      setLoading(false);
      setSelectedTitle(response?.title);
      bindContentAreas(response?.contentAreaId);
      bindSubjects(
        defaultSelectValue,
        response.subjectId,
        response.contentAreaId
      );
      bindGrades(defaultSelectValue, response.gradeId);
      bindStates(defaultSelectValue, response.stateId);
      setSupersheet(response);
    }

    if (supersheetSubjects) {
      bindMultipleSubject(supersheetSubjects.data);
    }
  };

  const isSelectAllSubjectSelected = () =>
    selectedSubjects?.length === grades?.length;

  const isOptionSelected = (option: any) =>
    selectedSubjects.some(({ value }: any) => value === option.value) ||
    isSelectAllSubjectSelected();

  function handleContentAreaChange(selectedItem: any) {
    setSelectedContentArea(selectedItem);
    bindSubjects(selectedItem);
  }

  async function bindGrades(selectedItem?: ISelectElement, gradeId?) {
    gradeId = selectedItem?.value == "0" ? gradeId : selectedItem?.value;

    const response = getGradeAll(999, 1);
    const data = (await response).data;
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      const gradesData = data.data.map((item) => {
        return { label: item.name, value: item.gradeId };
      });
      setGrades(gradesData);
      if (gradeId) {
        const selectedGrade = gradesData.find((t) => {
          return t.value === gradeId;
        });
        setSelectedGrade(selectedGrade);
      }
    }
  }
  async function bindStates(selectedItem?: ISelectElement, stateId?) {
    stateId = selectedItem?.value == "0" ? stateId : selectedItem?.value;
    const response = getStateAll(999, 1);
    const data = (await response).data;
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.stateId - secondItem.stateId
      );
      const statesData = data.data.map((item) => {
        return { label: item.name, value: item.stateId };
      });
      setStates(statesData);
      if (stateId) {
        const selectedState = statesData.find((t) => {
          return t.value === stateId;
        });
        setSelectedState(selectedState);
      }
    }
  }

  async function bindSubjects(
    selectedItem?: ISelectElement,
    subjectId?,
    contentAreaId?
  ) {
    const contentId =
      selectedItem?.value == "0" ? contentAreaId : selectedItem?.value;

    const service = await import("../../../api/subject.service");
    service
      .getSubjectAllByContent(parseInt(contentId || 0))
      .then((response) => {
        const result = response.data;
        const subjectsData = result.map((item) => {
          return { label: item.subjectName, value: item.subjectId };
        });

        setSubjects(subjectsData);
        if (subjectId) {
          const selectedSubject = subjectsData.find((t) => {
            return t.value === subjectId;
          });
          setSelectedSubject(selectedSubject);
        }
      });
  }

  async function bindMultipleSubject(data) {
    if (data) {
      const filteredSubjects: any = [];
      data.supersheetSubjectGroup.map((item) => {
        filteredSubjects.push({
          label: item.subjectName,
          value: item.subjectId,
        });
      });
      setSelectedSubjects(filteredSubjects);
    }
  }

  function handleSubjectChange(selectedItem: any) {
    setSelectedSubject(selectedItem);
  }
  async function bindContentAreas(contentAreaId?) {
    const service = await import("../../../api/contentArea.service");
    service.getContentArea().then((response) => {
      const result = response.data.data;
      const contentAreaData = result.map((item) => {
        return { label: item.name, value: item.contentAreaId };
      });
      setContentAreas(contentAreaData);
      if (parameters?.autoFillData?.contentId) {
        setSelectedContentArea({
          label: parameters.autoFillData.contentName,
          value: parameters.autoFillData.contentId,
        });
      }
      if (contentAreaId) {
        const selectedContentArea = contentAreaData.find((t) => {
          return t.value === contentAreaId;
        });
        setSelectedContentArea(selectedContentArea);
      }
    });
  }

  const getStates = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setStates(newStateData);
  };
  const getGrades = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      dropdownData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrades(dropdownData);
  };
  const onEnglishQuestionFileChange = (event) => {
    if (
      event?.target?.files?.length &&
      event?.target?.files[0]?.name
        ?.split(".")
        ?.pop()
        .toLowerCase()
        .includes("pdf")
    ) {
      setSelectedSupersheetFile(event.target.files[0]);
    } else {
      toast.warning("Invalid Supersheet file, It should be pdf");
    }
  };

  const onRationalesFileChange = (event) => {
    if (
      event?.target?.files?.length &&
      event?.target?.files[0]?.name
        ?.split(".")
        ?.pop()
        .toLowerCase()
        .includes("csv")
    ) {
      setSelectedRationalesFile(event.target.files[0]);
    } else {
      toast.warning("Invalid worksheet key file, It should be csv");
    }
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Supersheet", url: constant.SUPERSHEETS },
      {
        name: id ? "Edit Supersheet" : "Add Supersheet",
        url: "",
      },
    ];

    if (subjectId && id) {
      items.push({ name: id?.toString(), url: "" });
    }

    return items;
  };

  const handleDropdownChange = (e: Event, type: string) => {
    setIsLoaded(true);
    switch (type) {
      case "State":
        setSelectedState(e);
        break;
      case "Grade":
        setSelectedGrade(e);
        break;
      case "ContentArea":
        setSelectedContentArea(e);
        break;
    }
  };
  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  function handleRedirection(name: string, id: number) {
    if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }
  return (
    <AllowedTo
      perform={[Permissions.supersheet_create, Permissions.supersheet_modify]}
      no={() => <AccessDenied />}
    >
      <Fragment>
        {loading && <Loader />}

        <div className="flex-1 overflow-auto">
          <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
            <div className="relative  py-1">
              <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
              <div className="flex items-center justify-between pb-2">
                <h3 className="text-lg font-light text-gray-900">Supersheet</h3>
              </div>
              <Breadcrumb items={breadcrumbItems()} />
              <div className="mt-6 w-full">
                <div className="flex space-x-8">
                  <div className="w-1/4 border rounded-lg shadow mt-4 px-6">
                    <form onSubmit={handleSubmit(submitHandler)}>
                      <div className=" py-6  mt-4 px-6">
                        <div className="flex justify-end">
                          <div
                            className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                            onClick={() => toggleLang()}
                          >
                            <span
                              className={`${
                                lang === 1
                                  ? "bg-primary-color text-white"
                                  : "bg-white text-gray-400"
                              } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                            >
                              English
                            </span>
                            <span
                              className={`${
                                lang === 2
                                  ? "bg-primary-color text-white"
                                  : "bg-white text-gray-400"
                              } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                            >
                              Spanish
                            </span>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-2">
                          <div>
                            <label
                              className={`text-sm font-medium text-gray-700`}
                            >
                              Title
                            </label>

                            <div>
                              <input
                                id="title"
                                defaultValue={selectedTitle}
                                autoComplete="off"
                                type="text"
                                className={`block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm w-full`}
                                {...register("title", {
                                  required: true,
                                  value: supersheetInput.title,
                                })}
                              />
                              {errors.name &&
                                errors.name.type == "required" && (
                                  <span className="text-red-700 inline-block pt-1 text-sm">
                                    Title is required
                                  </span>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            {selectedContentArea?.value ? (
                              <a
                                className="text-gray-700 text-sm underline"
                                onClick={() =>
                                  handleRedirection(
                                    "content-areas",
                                    parseInt(selectedContentArea?.value)
                                  )
                                }
                                href={`/content-areas/edit/${parseInt(
                                  selectedContentArea?.value
                                )}`}
                              >
                                Content Area
                              </a>
                            ) : (
                              <button className="text-gray-700 text-sm cursor-default">
                                Content Area
                              </button>
                            )}
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedContentArea}
                              onChange={handleContentAreaChange}
                              options={contentAreas}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            {selectedSubject?.value ? (
                              <a
                                className="text-gray-700 text-sm underline"
                                onClick={() =>
                                  handleRedirection(
                                    "subject",
                                    parseInt(selectedSubject?.value)
                                  )
                                }
                                href={`/subjects/edit/${parseInt(
                                  selectedSubject?.value
                                )}`}
                              >
                                Subject
                              </a>
                            ) : (
                              <button className="text-gray-700 text-sm cursor-default">
                                Subject
                              </button>
                            )}
                          </div>
                          <div className="mt-1">
                            <MultiSelect
                              options={subjects}
                              selectedItems={selectedSubjects}
                              setSelectedItems={setSelectedSubjects}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center col-span-1">
                            <button className="text-gray-700 text-sm cursor-default">
                              Grade
                            </button>
                          </div>
                          <div
                            id="gradeFilter"
                            className="block mt-1 w-full col-span-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                          >
                            <Select
                              options={grades}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              value={selectedGrade}
                              onChange={(e) => {
                                handleDropdownChange(e, "Grade");
                              }}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            ></Select>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center col-span-1">
                            <label className="font-medium text-gray-700">
                              State
                            </label>
                          </div>
                          <div
                            id="gradeFilter"
                            className="block mt-1 w-full col-span-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                          >
                            <Select
                              options={states}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              value={selectedState}
                              onChange={(e) => {
                                handleDropdownChange(e, "State");
                              }}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            ></Select>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center">
                            <label className="font-medium text-gray-700">
                              {lang === 1 ? "English " : "Spanish "} Question
                              PDF
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              type="file"
                              id="EnglishQuestionPDF"
                              name="EnglishQuestionPDF"
                              onChange={onEnglishQuestionFileChange}
                              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center">
                            <label className="font-medium text-gray-700">
                              Rationales CSV
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              type="file"
                              id="EnglishRationalesCSV"
                              name="EnglishRationalesCSV"
                              onChange={onRationalesFileChange}
                              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                        <div className="flex justify-between pb-2 border-t mt-5 items-center">
                          <div>
                            <button
                              type="submit"
                              className=" cursor-pointer inline-flex items-center px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                            >
                              {id ? "Update" : "Save"}
                            </button>
                            <Link to={constant.SUPERSHEETS} className="ml-2">
                              <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                                Cancel
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="w-3/4">
                    {id && (
                      <Fragment>
                        <div className="flex items-center justify-between bg-gray-100 w-full">
                          <div className="flex">
                            <button
                              onClick={() => setActiveTab("EnglishQuestionPDF")}
                            >
                              <h2
                                className={
                                  activeTab === "EnglishQuestionPDF"
                                    ? activeTabClass
                                    : inActiveTabClass
                                }
                              >
                                Question PDF Preview
                              </h2>
                            </button>
                            <button
                              onClick={() => setActiveTab("EnglishRationales")}
                            >
                              <h2
                                className={
                                  activeTab === "EnglishRationales"
                                    ? activeTabClass
                                    : inActiveTabClass
                                }
                              >
                                Rationales Preview
                              </h2>
                            </button>
                          </div>
                        </div>
                        {activeTab === "EnglishQuestionPDF" &&
                          supersheet.englishPdfPath && (
                            <SupersheetFile
                              key={lang}
                              title={
                                supersheet.title
                                  ? "Supersheet File Preview"
                                  : "No Supersheet file attached"
                              }
                              filePath={
                                lang === 2
                                  ? supersheet.spanishPdfPath
                                  : supersheet.englishPdfPath
                              }
                              userId={props.profile?.userId}
                            />
                          )}

                        {activeTab === "EnglishRationales" && (
                          <SupersheetFile
                            title={
                              supersheet.title
                                ? "Supersheet File Preview"
                                : "No Supersheet file attached"
                            }
                            supersheetId={supersheet.superSheetId}
                            isAnswerKey={true}
                            userId={props.profile?.userId}
                          />
                        )}
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </AllowedTo> */}
      </Fragment>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(ManageSupersheet);
